/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/13
 * Time: 16:28
 * Desc: 活动类型设置
 */

import { Component, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';
import NoAuth from '@/views/components/noAuth/noAuth.vue';

@Component({
  components: {
    NoAuth,
  },
})
export default class ActivityTypeSetting extends Vue {
  /* 数据 */

  /**
   * loading状态
   * @type {boolean}
   */
  public loadingState = false;

  /**
   * 活动类型列表
   * @type {number}
   */
  public activityTypeList: Array<any> = [];

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 内容是否显示
   * @type {boolean}
   */
  public isContentBodyShow = false;

  /* 方法 */

  /**
   * 条数变更
   * @type {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getActivityTypeList();
  }

  /**
   * 页码变更
   * @type {number} val
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getActivityTypeList();
  }

  /**
   * 获取活动类型列表
   * @return null
   */
  public getActivityTypeList(): void {
    this.activityTypeList = [];
    const queryParams = {
      page: this.page,
      pageNum: this.pageSize,
    };
    IPSService.getActTypeList({ queryParams }).then((res) => {
      res.list.forEach((item) => {
        item.addPerson = Functions.emptyVaribleHandler(item.addPerson);
        item.addTime = Functions.emptyVaribleHandler(item.addTime);
        item.actSites = Functions.emptyVaribleHandler(item.actSites);
      });
      this.activityTypeList = res.list;
      this.totalCount = res.count;
    });
  }

  /**
   * 改变活动类型状态 禁用/启用/删除 api
   * @param {number} id
   * @param {number} type
   */
  public onChangeState(id: number, type: number) {
    if (type === 9) {
      this.$confirm('是否删除此活动类型?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning',
      }).then(() => {
        const postParams = {
          actTypeIds: [id],
          state: 9,
        };
        IPSService.updateActTypeStatus({ postParams }).then((res) => {
          if (res.ret) {
            this.$message.success('操作成功');
            this.page = 1;
            this.getActivityTypeList();
          } else {
            this.$message.error('操作失败');
          }
        });
      });
    } else {
      const postParams = {
        actTypeIds: [id],
        state: type,
      };
      IPSService.updateActTypeStatus({ postParams }).then((res) => {
        if (res.ret) {
          this.$message.success('操作成功');
          this.page = 1;
          this.getActivityTypeList();
        } else {
          this.$message.error('操作失败');
        }
      });
    }
  }

  /**
   * 跳转活动类型配置页
   * @param {number} id
   */
  public onToActTypeEdit(id): void {
    this.loadingState = true;
    this.$router.push(`/activityTypeSetting/edit/${id}`);
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    // 权限检测
    this.isContentBodyShow = this.$store.state.authMenuCodeList.includes('VSHOP-FUNCTION-BASIC-ACTIVITY');
    if (this.isContentBodyShow) {
      this.getActivityTypeList(); // 获取活动类型列表
    }
  }
}
